<script setup lang="ts">
const props = withDefaults(defineProps<{
  src?: string | null
  alt?: string
  loading?: 'lazy' | 'eager'
  decoding?: 'async' | 'sync' | 'auto'
  fetchpriority?: 'high' | 'low' | 'auto'
  progressive?: boolean
}>(), {
  src: '',
  alt: '',
  loading: 'lazy',
  decoding: 'async',
  fetchpriority: 'auto',
  progressive: true
})

const imgRef = ref<HTMLImageElement | null>(null)
const isLoaded = ref(false)
const isError = ref(false)

const resetState = () => {
  isLoaded.value = false
  isError.value = false
}

const syncLoadedState = () => {
  const img = imgRef.value
  if (!img) {
    return
  }
  if (img.complete && img.naturalWidth > 0) {
    isLoaded.value = true
  }
}

const onLoad = () => {
  isLoaded.value = true
}

const onError = () => {
  isError.value = true
  isLoaded.value = true
}

watch(
  () => props.src,
  () => {
    resetState()
    nextTick(() => {
      syncLoadedState()
    })
  }
)

onMounted(() => {
  syncLoadedState()
})
</script>

<template>
  <img
    ref="imgRef"
    :src="src || ''"
    :alt="alt"
    :loading="loading"
    :decoding="decoding"
    :fetchpriority="fetchpriority"
    :class="[
      'blog-progressive-img',
      {
        'is-loaded': isLoaded,
        'is-error': isError,
        'is-progressive': progressive
      }
    ]"
    @load="onLoad"
    @error="onError"
  />
</template>

